import { API_DOMAIN_DEFAULT } from '../../../model/model';
import { isDefined, isNotDefined, isFunction, not, notSingleEle, truthy, falsy, each, getDefined, allOf } from '../../../utils/util';
import { getLoadingBarTpl, getSavedEquipTpl } from './../model/tpl/equip';
import { getSavedUserEquips, getSavedUserEquip, getUserSlotsStatus, getSavedUserStats, getStatNoEquips, deleteSavedEquip, setOrgStats } from './../utils/service';
import { handleApiError } from '../../../utils/service';
import { ALERT, MSG } from '../model/msg/equip';
import EquipModel from './EquipModel';
import SelectStatLayer from './selectStatLayer/SelectStatLayer';
import EquipSimulator from './EquipSimulator';
import SingletonLoading from './../utils/SingletonLoading';
import moment from 'moment';

class Equip {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('Equip constructor require options object');

    _.option = $.extend({
      deviceType: '',
      wrap: null,
      apiDomain: API_DOMAIN_DEFAULT,
      searchApiDomain: API_DOMAIN_DEFAULT,
      isLogin: false,
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.selectStatWrap = null;
    _.equipStorageWrap = null;
    _.displayNoEquipItem = null;
    _.savedEquipWrap = null;
    _.equipSimulatorWrap = null;

    _.selectStatLayer = null;
    _.equipSimulator = null;

    _.global = _.option.global;

    _.orgdata = null;
  }

  init() {
    const _ = this;

    _.model.isLogin = _.option.isLogin;
    _.model.DEVICE_TYPE = _.option.deviceType;

    _.wrap = $(_.option.wrap);
    if (notSingleEle(_.wrap)) throw new Error('Equip wrap must be single element.');

    _.selectStatWrap = $('.wrap-simulator', _.wrap);
    _.equipStorageWrap = $('> .simulator-storage', _.selectStatWrap);
    _.displayNoEquipItem = $('.nodata', _.equipStorageWrap);
    _.savedEquipWrap = $('.storage-bundle', _.equipStorageWrap);
    _.equipSimulatorWrap = $('.wrap-simulator-body', _.wrap);

    // set loading bar template
    $('.wrap-contents', _.wrap).append(getLoadingBarTpl());
    _.loading.setLoadingBar($('.loadingbar', _.wrap)).end();

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.showEquipSimulatorWrap(false);

    _.setBtns();

    _.setSelectStatLayer();

    if (truthy(_.model.isLogin)) {
      // _.showNoEquipStorageItems(false);
      _.setSavedEquipStorage();
    }
  }

  setBtns() {
    const _ = this;

    $('.btn-simulator', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (_.getSavedUserEquipNum() >= _.model.USER_EQUIP_NUM_LIMIT) {
        const isConfirmSimulateEquip = _.global.confirm(ALERT.SAVE_EQUIP_LIMIT); // 장비 세팅 저장은 계정당 최대 6개까지 가능합니다. 새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요. 장비 세팅을 계속 진행하시겠습니까?`
        if (truthy(isConfirmSimulateEquip)) {
          _.showEquipStorage(false);
          _.selectStatLayer.show(true);
        }

      } else {
        _.showEquipStorage(false);
        _.selectStatLayer.show(true);
      }
    });

    // before login
    $('.btn-login', _.wrap).on('click', function (evt) {
      evt.preventDefault();

      if (isFunction(_.global.GNBLogin)) _.global.GNBLogin();
    });
  }

  setSelectStatLayer() {
    const _ = this;

    _.selectStatLayer = new SelectStatLayer({
      wrap: $('.simulator-select', _.selectStatWrap),
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain
    }).init();

    $(_.selectStatLayer).on(SelectStatLayer.EVT_CLOSE, function (evt) {
      _.showEquipStorage(true);
      _.selectStatLayer.show(false);
    });

    $(_.selectStatLayer).on(SelectStatLayer.EVT_SELECT_MY_STAT, function (evt) {


      if (truthy(_.loading.isLoading)) return;

      const obj = evt.obj;

      _.orgdata = obj;

      console.log('EVT_SELECT_MY_STAT obj :', obj );
      console.log( '## selectSettingLayer/MyCharacterStats.js > select setOrgStats(data)  ##', setOrgStats({data: obj}) );
      setOrgStats({data: obj}); // 201908 org stats data push


      _.showEquipStorage(true);
      _.showSelectStatWrap(false);
      _.selectStatLayer.show(false);

      _.setEquipSimulator({
        page: 'default',
        statType: 'my',
        serverId: obj.serverId,
        serverName: obj.serverName,
        classId: obj.classId,
        classImageUrl: obj.classImageUrl,
        characterName: obj.characterName,
        level: obj.level,
        hp: obj.hp,
        mp: obj.mp,
        noEquipStats: obj.noEquipStats, // null, or {mainStat, subStat, formattedSubStat}
        stats: obj.stats, // {mainStat, subStat, formattedSubStat}
        expandSlots: obj.expandSlots, // {isShoulderSlot, isEarringSlot, ...}
        equipItems: obj.equipItems, // [{enchant, itemId, itemName, slot}, ...]
        // changedStats: obj.changedStats,
        isEditable: obj.isEditable,
        memo: '',
        idx: ''
      });

      _.showEquipSimulatorWrap(true);
    });

    $(_.selectStatLayer).on(SelectStatLayer.EVT_SELECT_SAVED_STAT, function (evt) {
      console.log('EVT_SELECT_SAVED_STAT');

      if (truthy(_.loading.isLoading)) return;

      const obj = evt.obj; // {idx, classId, classImageUrl, level, mainStat: {STR, DEX, ...}}

      _.orgdata = obj;


      console.log( '## selectSettingLayer/MyCharacterStats.js > select setOrgStats(data)  ##', setOrgStats({data: obj}) );
      setOrgStats({data: obj}); // 201908 org stats data push


      _.showEquipStorage(true);
      _.showSelectStatWrap(false);
      _.selectStatLayer.show(false);

      console.log('Equip.js getStatNoEquips obj : ', obj );

      getStatNoEquips({
        apiDomain: _.option.apiDomain,
        searchApiDomain: _.option.searchApiDomain,
        sendData: {
          classId: obj.classId,
          level: obj.level,
          hp: obj.hp,
          mp: obj.mp,
          idx: obj.idx, // 2019 . 12 . 저장한 스탯을 불러올 때 idx 를 전달
          currentStat: obj.mainStat
        },
        beforeSend: () => _.loading.start()

      }).then(function (data, textStatus, jqXHR) {
        console.log('getStatNoEquips - data :', data);

        _.loading.end();

        _.setEquipSimulator({
          page: 'default',
          statType: 'setting',
          serverId: _.model.DEFAULT_SERVER_ID,
          serverName: '',
          classId: obj.classId,
          classImageUrl: obj.classImageUrl,
          characterName: '',
          level: obj.level,
          hp: data.formattedSubStat.hp,
          mp: data.formattedSubStat.mp,
          stats: data, // {mainStat, subStat, formattedSubStat}
          expandSlots: null,
          equipItems: [],
          // changedStats: null,
          isEditable: true,
          memo: '',
          idx: ''
        });

        _.showEquipSimulatorWrap(true);


      }).catch(function (err) {
        console.log('getStatNoEquips - error :', err);

        _.loading.end();

        if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_STAT); // '현재 저장된 스탯 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      });
    });
  }

  setSavedEquipStorage() {
    const _ = this;

    $('.storage__equip', _.equipStorageWrap).off('click').remove();

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/equip/user
    getSavedUserEquips({
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('Equip.js > getSavedUserEquips - data :', data);

      _.loading.end();

      if (truthy(Array.isArray(data))) {
        if (data.length > 0) {
          _.showNoEquipStorageItems(false);

          // sort by descending date order
          data.sort((a, b) => new Date(b.userEquipInfo.updateDate).getTime() - new Date(a.userEquipInfo.updateDate).getTime());

          let tplFunc, tpl = '';
          each(data, function (item) {
            tplFunc = doT.template(getSavedEquipTpl(true));

            const characterInfo = item.userEquipInfo.characterInfo || {};

            // sort by equip slots order
            let equipItems = item.displayEquipItemList || [];
            equipItems.sort((a, b) => _.model.SLOT_NAMES.indexOf(a.slot) - _.model.SLOT_NAMES.indexOf(b.slot));

            tpl += tplFunc({
              baseStatType: item.userEquipInfo.baseStatType,
              idx: item.userEquipInfo.idx,
              classImageUrl: item.userEquipInfo.classImageUrl,
              name: getDefined(characterInfo.characterName, ''),
              serverName: getDefined(characterInfo.serverName, ''),
              level: item.userEquipInfo.level,
              date: moment(item.userEquipInfo.updateDate).format('YYYY.MM.DD'),
              equips: equipItems.slice(0, 4),
              memo: item.userEquipInfo.memo || MSG.NO_SAVED_EQUIP_SETTING_TITLE,
              memoOriginal: item.userEquipInfo.memo || ''
            });
          });

          _.savedEquipWrap.prepend(tpl);

          $('.storage__equip', _.equipStorageWrap).on('click', function (evt) {
            evt.preventDefault();

            if(truthy(_.loading.isLoading)) return;

            _.loading.start();

            const idx = $(this).attr('data-idx');

            if($(evt.target).hasClass('btn-delete')) {
              if (allOf(isDefined(idx), idx !== '')) {
                const msg = ALERT.TRY_DELETE_EQUIP({memo: $(this).attr('data-memo-original')}),
                  isConfirmDelete = _.global.confirm(msg); // ${data.memo} 장비 세팅을 삭제하시겠습니까?

                (isConfirmDelete) ? _.deleteEquipSetting(idx) : _.loading.end();
              }

              return;
            }

            const baseStatType = $(this).attr('data-base-stat-type');
            switch (baseStatType) {
              case 'my':
                (async function() {
                  try {
                    _.loading.start();
                    console.log('Equip.js case:my');

                    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/equip/user/:idx
                    const userEquipData = await getSavedUserEquip({
                      apiDomain: _.option.apiDomain,
                      searchApiDomain: _.option.searchApiDomain,
                      idx: idx
                    });

                    const userEquipInfo = userEquipData.userEquipInfo,
                      characterInfo = userEquipInfo.characterInfo || {};

                    console.log('Equip.js userEquipInfo :', userEquipInfo);
                    console.log('Equip.js characterInfo :', characterInfo);


                    const noEquipStats = await getStatNoEquips({
                      apiDomain: _.option.apiDomain,
                      searchApiDomain: _.option.searchApiDomain,
                      sendData: {
                        classId: userEquipInfo.classId,
                        level: userEquipInfo.level,
                        hp: userEquipInfo.statMetaInfo.hp,
                        mp: userEquipInfo.statMetaInfo.mp,
                        currentStat: userEquipInfo.statMetaInfo.mainStat
                      }
                    });

                    const expandSlots = await getUserSlotsStatus({
                      apiDomain: _.option.apiDomain,
                      searchApiDomain: _.option.searchApiDomain,
                      serverId: characterInfo.serverId,
                      characterName: characterInfo.characterName
                    });

                    // console.log('Equip.js userEquipData :', userEquipData);
                    // console.log('Equip.js noEquipStats :', noEquipStats);
                    // console.log('Equip.js expandSlots :', expandSlots);


                    //console.log( '## Equip.js > case:my setOrgStats(data) userEquipData.userEquipInfo.statMetaInfo : ', userEquipData.userEquipInfo.statMetaInfo );
                    //setOrgStats({data: userEquipData.userEquipInfo.statMetaInfo }); // 201908 org stats data push


                    _.loading.end();

                    _.setEquipSimulator({
                      page: 'view',
                      statType: userEquipInfo.baseStatType,
                      serverId: getDefined(characterInfo.serverId, _.model.DEFAULT_SERVER_ID),
                      serverName: getDefined(characterInfo.serverName, ''),
                      classId: userEquipInfo.classId,
                      classImageUrl: userEquipInfo.classImageUrl,
                      characterName: getDefined(characterInfo.characterName, ''),
                      level: userEquipInfo.level,
                      hp: noEquipStats.formattedSubStat.hp,
                      mp: noEquipStats.formattedSubStat.mp,
                      noEquipStats: noEquipStats,
                      stats: userEquipData.equipSimulationStat,
                      expandSlots: expandSlots,
                      equipItems: userEquipData.displayEquipItemList,
                      // changedStats: null, // obj.changedStats,
                      isEditable: false,
                      memo: userEquipData.userEquipInfo.memo,
                      idx: userEquipData.userEquipInfo.idx // saved equip idx
                    });

                    _.equipSimulator.displayTotalPrice(userEquipData.displayTotalPrice);

                    _.showEquipSimulatorWrap(true);
                    _.showSelectStatWrap(false);

                    _.showEquipStorage(false);

                  } catch (error) {
                    _.loading.end();

                    if (falsy(handleApiError(error.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
                  }
                }());

                break;

              case 'setting':
                (async function() {
                  try {
                    _.loading.start();

                    console.log('Equip.js case:setting');
                    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-GET/api/simulator/equip/user/:idx
                    const userEquipData = await getSavedUserEquip({
                      apiDomain: _.option.apiDomain,
                      searchApiDomain: _.option.searchApiDomain,
                      idx: idx
                    });

                    const userEquipInfo = userEquipData.userEquipInfo,
                      characterInfo = userEquipInfo.characterInfo || {};


                      console.log( '## Equip.js > case:setting setOrgStats(data)  ##', userEquipInfo.statMetaInfo );
                      setOrgStats({data: userEquipInfo.statMetaInfo}); // 201908 org stats data push


                      const noEquipStats = await getStatNoEquips({
                        apiDomain: _.option.apiDomain,
                        searchApiDomain: _.option.searchApiDomain,
                        sendData: {
                          classId: userEquipInfo.classId,
                          level: userEquipInfo.level,
                          hp: userEquipInfo.statMetaInfo.hp,
                          mp: userEquipInfo.statMetaInfo.mp,
                          currentStat: userEquipInfo.statMetaInfo.mainStat
                        }
                      });

                    console.log('Equip.js userEquipInfo :', userEquipInfo );
                    // console.log('Equip.js characterInfo :', characterInfo);
                    console.log('Equip.js  noEquipStats :', noEquipStats);

                    _.loading.end();



                    _.setEquipSimulator({
                      page: 'view',
                      statType: userEquipInfo.baseStatType,
                      serverId: getDefined(characterInfo.serverId, _.model.DEFAULT_SERVER_ID),
                      serverName: getDefined(characterInfo.serverName, ''),
                      classId: userEquipInfo.classId,
                      classImageUrl: userEquipInfo.classImageUrl,
                      characterName: getDefined(characterInfo.characterName, ''),
                      level: userEquipInfo.level,
                      noEquipStats: noEquipStats,
                      hp: noEquipStats.formattedSubStat.hp,
                      mp: noEquipStats.formattedSubStat.mp,
                      stats: userEquipData.equipSimulationStat,
                      expandSlots: null,
                      equipItems: userEquipData.displayEquipItemList,
                      // changedStats: null, // obj.changedStats,
                      isEditable: false,
                      memo: userEquipData.userEquipInfo.memo,
                      idx: userEquipData.userEquipInfo.idx // saved equip idx
                    });


                    _.equipSimulator.displayTotalPrice(userEquipData.displayTotalPrice);

                    _.showEquipSimulatorWrap(true);
                    _.showSelectStatWrap(false);

                    _.showEquipStorage(false);

                  } catch (error) {
                    _.loading.end();

                    if (falsy(handleApiError(error.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
                  }
                }());

                break;
            }
          });

        } else {
          _.showNoEquipStorageItems(true);
        }

      } else {
        _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch((err) => {
      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_LOAD_SAVED_EQUIP); // '현재 저장된 장비 데이터를 가져올 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  getSavedUserEquipNum() {
    return $('.storage__equip', this.equipStorageWrap).length;
  }

  deleteEquipSetting(idx) {
    const _ = this;

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/equip/user/:idx
    deleteSavedEquip({
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      idx: idx,
      beforeSend: () => _.loading.start()

    }).then(function (data, textStatus, jqXHR) {
      _.loading.end();

      if (data.result === 'success') {
        // remove stat item
        $('.storage-bundle .storage__equip', _.option.wrap).filter(function () {
          return $(this).attr('data-idx') === idx;
        }).remove();

        _.showNoEquipStorageItems( $('section article.storage__equip').length<1 );
      } else {
        if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_DELETE_EQUIP); // '현재 장비 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch(function (err) {
      console.log('deleteSavedEquip - error :', err);

      _.loading.end();

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_DELETE_EQUIP); // '현재 장비 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  /*
   * equip simulator
   */
  setEquipSimulator(data) {
    const _ = this;

    setOrgStats({data: data}); // 201908 org stats data push
    console.log('Equip.js setEquipSimulator(data) data :', data);
    console.log('Equip.js setEquipSimulator() _.orgdata :', _.orgdata );


    _.equipSimulator = new EquipSimulator({
      wrap: _.equipSimulatorWrap,
      apiDomain: _.option.apiDomain,
      searchApiDomain: _.option.searchApiDomain,
      data: data
    }).init();

    $(_.equipSimulator).on(EquipSimulator.EVT_CLOSE, function (evt) {
      _.destroyEquipSimulator();

      _.showEquipSimulatorWrap(false);
      _.showSelectStatWrap(true);
      _.showEquipStorage(true);
    });

    $(_.equipSimulator).on(EquipSimulator.EVT_SAVE_EQUIP, function (evt) {
      _.destroyEquipSimulator();

      _.showEquipSimulatorWrap(false);
      _.showSelectStatWrap(true);
      _.showEquipStorage(true);

      _.setSavedEquipStorage();
    });

    $(_.equipSimulator).on(EquipSimulator.EVT_DELETE_EQUIP_COMPLETE, function (evt) {
      _.destroyEquipSimulator();

      _.showEquipSimulatorWrap(false);
      _.showSelectStatWrap(true);
      _.showEquipStorage(true);

      _.setSavedEquipStorage();
    });
  }

  destroyEquipSimulator() {
    const _ = this;

    if (isDefined(_.equipSimulator)) {
      $(_.equipSimulator)
        .off(EquipSimulator.EVT_CLOSE)
        .off(EquipSimulator.EVT_SAVE_EQUIP)
        .off(EquipSimulator.EVT_DELETE_EQUIP_COMPLETE);

      _.equipSimulator.destroy();
      _.equipSimulator = null;
    }
  }

  showEquipSimulatorWrap(flag) {
    (truthy(flag)) ? this.equipSimulatorWrap.show() : this.equipSimulatorWrap.hide();
  }

  showSelectStatWrap(flag) {
    (truthy(flag)) ? this.selectStatWrap.show() : this.selectStatWrap.hide();
  }

  showEquipStorage(flag) {
    (truthy(flag)) ? this.equipStorageWrap.show() : this.equipStorageWrap.hide();
  }

  showNoEquipStorageItems(flag) {
    (truthy(flag)) ? this.displayNoEquipItem.show() : this.displayNoEquipItem.hide();
    (truthy(flag)) ? $('.simulator-storage footer').hide() : $('.simulator-storage footer').show();
  }
}

export default Equip;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/Equip.js